import { getSearchConsoleDataLocal, getGa4DataLocal } from '@/services/locator/analytics.service'
import { getLocatorListAPI } from '@/services/locator/LocatorConfiguration.service'

const GET_LOCATORS_LIST = 'GET_LOCATORS_LIST'
const SET_CURRENT_LOCATOR = 'SET_CURRENT_LOCATOR'
const GET_SEARCH_CONSOLE_LOCAL = 'GET_SEARCH_CONSOLE_LOCAL'
const GET_GA4_LOCAL = 'GET_GA4_LOCAL'
const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    locatorsList: [],
    currentLocator: null,
    localSearchConsoleData: null,
    localGa4Data: null,
  }
}

const state = getDefaultState()

const mutations = {
  [GET_LOCATORS_LIST]: (state, locatorsList) => {
    state.locatorsList = locatorsList
  },
  [SET_CURRENT_LOCATOR]: (state, currentLocator) => {
    state.currentLocator = currentLocator
  },
  [GET_SEARCH_CONSOLE_LOCAL](state, payload) {
    state.localSearchConsoleData = payload
  },
  [GET_GA4_LOCAL](state, payload) {
    state.localGa4Data = payload
  },
  [RESET_STATE]: state => {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  // Locators
  async getLocatorsList({ commit, rootState }) {
    const locatorsList = await getLocatorListAPI(rootState.backoffice.currentClient.uuid)
    commit(GET_LOCATORS_LIST, locatorsList)
  },
  async setCurrentLocator({ commit }, locatorSlug) {
    const currentLocator = state.locatorsList.find(locator => locator.slug === locatorSlug)

    commit(SET_CURRENT_LOCATOR, currentLocator)
  },

  // Dashboard
  async fetchLocalSearchConsole({ commit, rootState, dispatch, state }, { period }) {
    dispatch('backoffice/setWorking', true, { root: true })

    try {
      const payload = await getSearchConsoleDataLocal(
        rootState.backoffice.currentClient.uuid,
        state.currentLocator.slug,
        period
      )
      const dto = payload?.data ?? payload
      commit(GET_SEARCH_CONSOLE_LOCAL, dto)
    } catch (error) {
      console.error('Search Console Error:', error)
      commit(GET_SEARCH_CONSOLE_LOCAL, null)
      dispatch(
        'backoffice/setAlert',
        {
          color: 'error',
          text: 'Error retrieving Search Console data.',
        },
        { root: true }
      )
    }
    dispatch('backoffice/setWorking', false, { root: true })
  },

  async fetchLocalGa4({ commit, rootState, dispatch, state }, { period }) {
    dispatch('backoffice/setWorking', true, { root: true })

    try {
      const payload = await getGa4DataLocal(rootState.backoffice.currentClient.uuid, state.currentLocator.slug, period)
      const dto = payload?.data ?? payload
      commit('GET_GA4_LOCAL', dto)
    } catch (error) {
      console.error('GA4 error:', error)
      commit(GET_GA4_LOCAL, null)
      dispatch(
        'backoffice/setAlert',
        {
          color: 'error',
          text: 'Error retrieving GA4 data.',
        },
        { root: true }
      )
    }
    dispatch('backoffice/setWorking', false, { root: true })
  },

  resetState({ commit }) {
    commit(RESET_STATE)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
